import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';

const APPLY_DELAYS_MS = [0, 50, 150];

@Directive({
  selector: 'b3-toast[b3DsToastSingleLine]',
  standalone: false,
})
export class B3DsToastSingleLineDirective implements AfterViewInit, OnDestroy {
  private readonly timeouts: number[] = [];
  private readonly host: HTMLElement;

  constructor(elementRef: ElementRef<HTMLElement>) {
    this.host = elementRef.nativeElement;
  }

  ngAfterViewInit(): void {
    this.host.addEventListener('b3-open', this.applyStyles);
    this.scheduleApply();
  }

  ngOnDestroy(): void {
    this.host.removeEventListener('b3-open', this.applyStyles);
    this.timeouts.forEach((id) => window.clearTimeout(id));
  }

  private scheduleApply(): void {
    requestAnimationFrame(() => this.applyStyles());
    APPLY_DELAYS_MS.forEach((delay) => {
      this.timeouts.push(window.setTimeout(() => this.applyStyles(), delay));
    });
  }

  private applyStyles = (): void => {
    const shadow = this.host.shadowRoot;

    if (!shadow) {
      return;
    }

    const toast = shadow.querySelector('.b3-toast');
    const content = shadow.querySelector('.b3-toast__content');
    const label = shadow.querySelector('.b3-toast__label');

    if (!(toast instanceof HTMLElement)) {
      return;
    }

    toast.style.setProperty('width', 'max-content', 'important');
    toast.style.setProperty('flex-wrap', 'nowrap', 'important');
    toast.style.setProperty('align-items', 'center', 'important');
    toast.style.setProperty('max-width', 'calc(100vw - var(--spacing-md, 16px) * 2)', 'important');

    if (content instanceof HTMLElement) {
      content.style.setProperty('flex', '0 0 auto', 'important');
      content.style.setProperty('min-width', 'max-content', 'important');
    }

    if (label instanceof HTMLElement) {
      label.style.setProperty('white-space', 'nowrap', 'important');
    }
  };
}
